/** @jsxImportSource @emotion/react */
import { Grid, Typography } from '@mui/material';
import React from 'react';
import ExpansionGrid from '../../Components/ExpansionGrid';

function PanDetailsReview(props) {
    const { reviewData } = props

    const apiKeysUsedForDisplayingLabel = {
        "panNo": "PAN Number",
        "isKRAVerified": "Is KRA Verified",
        "dob": "Date Of Birth",
        "segmentDesc": "Segment"
    }
    
    const getDOB = (value)=>{
        let date = new Date(Number(value))
        return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    }

    const getAccordianData = () => {
        return <Grid container spacing={3} css={{padding:"10px"}}>
            {Object.keys(apiKeysUsedForDisplayingLabel).map(apiKey=>
                <Grid container item xs={6} md={3} lg={2} alignItems={"center"} css={{border:"1px dashed lightgrey"}}>
                    <Grid item xs={12}>
                        <Typography variant="body2" css={{color:"#0098B0"}}>{apiKeysUsedForDisplayingLabel[apiKey]}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" /* color="#333333" fontWeight={"bold"} */ css={{wordBreak:"break-word"}}>
                            {reviewData && reviewData.kycStagingPandetails && 
                                (apiKey == "dob" ? getDOB(reviewData.kycStagingPandetails[apiKey]) : apiKey == "isKRAVerified" ? (reviewData.kycStagingPandetails[apiKey] ? "Yes" : "No") 
                                    : reviewData.kycStagingPandetails[apiKey]
                                ) || "--"
                            }
                        </Typography>
                    </Grid>
                </Grid>
            )}
        </Grid>
    }

    return (
        <ExpansionGrid title={"PAN Details"} accordianData={getAccordianData()} />
    );
}

export default PanDetailsReview;